import { format, parse, useDateFnsLocale } from '@if/core/date'
import { useTranslation } from 'react-i18next'

export const useFormatFundingDate = () => {
  const { i18n } = useTranslation()
  const { locale } = useDateFnsLocale()

  return (dateStr: string) => {
    try {
      const date = parse(dateStr, 'yyyy-MM-dd', new Date())
      if (i18n.language === 'fr') {
        return format(date, 'd MMMM yyyy', { locale })
      }
      return format(date, 'MMM. d, yyyy', { locale })
    } catch {
      return dateStr
    }
  }
}
